import AppContainer from './AppContainer'

export default AppContainer



// WEBPACK FOOTER //
// ./src/containers/AppContainer/index.js